<template>
  <a-spin :spinning="spinning" tip="Loading...">
    <div>
      项目名称：{{ info.name }}
      <br />
      编译版本：{{ info.version }}
      <br />
      编译时间：{{ info.time.replace("T", " ") }}
      <br />
      <br />
      <a-tag color="blue">
        <a href="mailto:yangdingjie@sanss.com" target="_blank">
          <a-icon type="mail" />&nbsp;联系管理员
        </a>
      </a-tag>
    </div>
  </a-spin>
</template>
<script>
export default {
  data() {
    return {
      spinning: true,
      info: { name: "", version: "", time: "" },
    };
  },
  mounted() {
    this.load();
  },
  created() {
    this.$store.state.routes = this.routes;
    this.$store.commit("setRoutes", this.routes);
  },
  methods: {
    load() {
      this.axios({
        url: "/build/actuator/info",
        method: "get",
      })
        .then((response) => {
          if (response.data.build) {
            this.info = response.data.build;
          }
          this.spinning = false;
        })
        .catch((response) => {
          this.spinning = false;
          // eslint-disable-next-line
          console.log(response);
        });
    },
  },
};
</script>

<style scoped>
div {
  font-size: 16px;
}
</style>
